import React, { useState, useEffect } from "react";
import API from "../../Utils/api";
import toast from "react-hot-toast";
import Banner from "../../components/UserSideComponents/common/Banner";
import Bannerimg from "../../Assets/banner.png";
import img1 from "../../Assets/carrier/img-1.png";
import img2 from "../../Assets/carrier/img-2.png";
import img3 from "../../Assets/carrier/img-3.png";
import img4 from "../../Assets/carrier/img-4.png";
import img5 from "../../Assets/carrier/img-5.png";
import img6 from "../../Assets/carrier/img-6.png";

const Carrier = () => {
  const [carrier, setCarrier] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCarrier = async () => {
    setLoading(true);
    try {
      const res = await API.get(`/carrier/get-all`);

      setCarrier(res.data?.carrier || []);
      console.log("response", res);
    } catch (error) {
      console.error("Error fetching Hero:", error);
      toast.error("Failed to load Carrier");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchCarrier();
  }, []);

  const carrierValue = [
    {
      image: img1,
      title: "courageous",
    },
    {
      image: img2,
      title: "curious",
    },
    {
      image: img3,
      title: "creative",
    },
    {
      image: img4,
      title: "caring",
    },
  ];

  return (
    <>
      <Banner image={Bannerimg} heading={"Carrier"} />
      <div className="px-4 sm:px-6 md:px-10 py-10 min-h-screen bg-yellow-50/30">
        <div className="flex flex-col items-center justify-center text-center mb-10">
          <p className="text-[#92AD36] text-sm font-semibold tracking-widest uppercase">
            Carrier Section
          </p>
          <h2 className="text-2xl md:text-4xl font-serif  text-black mt-3">
            Start Carrier With Us
          </h2>
          <div className="flex mt-4 gap-2">
            <span className="w-10 h-1 bg-[#92AD36]" />
            <span className="w-3 h-1 bg-[#92AD36]" />
            <span className="w-5 h-1 bg-[#92AD36]" />
          </div>
        </div>

        {/* Loader */}
        {loading ? (
          <div className="text-center text-lg font-semibold">Loading...</div>
        ) : carrier.length === 0 ? (
          <div className="text-center text-gray-500">No data found</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">
            {carrier.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-md overflow-hidden"
              >
                {/* Image */}
                <img
                  src={item.image?.[0]}
                  alt={item.heading}
                  className="w-full h-[250px] md:h-[400px] object-cover"
                />

                {/* Content */}
                <div className="p-5">
                  <h3 className="text-xl md:text-2xl font-bold text-black mb-3">
                    {item.heading}
                  </h3>
                  <p className="text-gray-600 text-sm md:text-base">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 mt-10 gap-8">
          <div className="flex flex-col">
            <div className="flex gap-4">
              <span className="w-2 h-12 bg-[#92AD36] rounded"></span>
              <h2 className="text-3xl md:text-4xl font-serif text-gray-900">
                Collaboration Sparks Possibility
              </h2>
            </div>

            <p className="text-gray-600 text-base md:text-lg leading-relaxed ml-6 mt-5">
              Collaboration drives everything we do, ensuring that every
              perspective adds value, every voice is heard, and every
              achievement is celebrated. Here, you’ll find the freedom to grow,
              the support to succeed, and the purpose to make a real impact.
            </p>

            <img src={img5} alt="" className="items-start w-48 mt-10 ml-6" />
          </div>
          <img src={img6} alt="" className="w-full rounded-xl" />
        </div>
        <div className="flex items-center gap-4 mt-10">
          <span className="w-2 h-12 bg-[#92AD36] rounded"></span>
          <h2 className="text-3xl md:text-4xl font-serif text-gray-900">
            Values that define us
          </h2>
        </div>

        <p className="text-gray-600 text-base md:text-lg leading-relaxed ml-6">
          Guided by our values since 1946, PL continues to grow while caring for
          its people and the planet.
        </p>

        <div className="w-full mt-8">
          <div className="flex flex-col sm:flex-row gap-8">
            {carrierValue.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center text-center hover:shadow-xl transition duration-300"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-1/2 object-contain mb-4"
                />

                <h3 className="text-lg md:text-xl font-semibold text-gray-800 uppercase tracking-wide">
                  {item.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Carrier;
